import { PUBLIC_WEB_ASSETS } from './publicWebData';
let pending;
export function loadPublicMap() {
  if (window.L?.map && window.L?.tileLayer) return Promise.resolve(window.L);
  if (pending) return pending;
  pending = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `${PUBLIC_WEB_ASSETS}/leaflet-1.9.4.js`;
    script.async = true; script.dataset.caPublicMap = 'true';
    const timer = setTimeout(() => fail(), 15000);
    const fail = () => { clearTimeout(timer); script.onload = null; script.onerror = null; script.remove(); pending = null; reject(new Error('Mapa no disponible')); };
    script.onload = () => {
      clearTimeout(timer);
      if (!window.L?.map || !window.L?.tileLayer) { fail(); return; }
      resolve(window.L);
    };
    script.onerror = fail;
    document.head.appendChild(script);
  });
  return pending;
}
